import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, AppConfig } from '@core/models';
import { Observable, of } from 'rxjs';

export enum LogLevel {
  EMERGENCY = 'emergency', // system is unusable
  ALERT = 'alert', // action must be taken immediately
  CRITICAL = 'critical', // critical conditions
  ERROR = 'error', // error conditions
  WARN = 'warn', // warning conditions
  NOTICE = 'notice', // normal but significant condition
  INFO = 'info', // informational messages
  DEBUG = 'debug', // debug-level messages
}

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: AppConfig
  ) {}

  logDebug = (message: string, path?: string): Observable<unknown> => this.log(LogLevel.DEBUG, message, path);

  logInfo = (message: string, path?: string): Observable<unknown> => this.log(LogLevel.INFO, message, path);

  logNotice = (message: string, path?: string): Observable<unknown> => this.log(LogLevel.NOTICE, message, path);

  logWarn = (message: string, path?: string): Observable<unknown> => this.log(LogLevel.WARN, message, path);

  logError = (message: string, path?: string, stack?: string): Observable<unknown> =>
    this.log(LogLevel.ERROR, message, path, stack);

  logCritical = (message: string, path?: string, stack?: string): Observable<unknown> =>
    this.log(LogLevel.CRITICAL, message, path, stack);

  logAlert = (message: string, path?: string, stack?: string): Observable<unknown> =>
    this.log(LogLevel.ALERT, message, path, stack);

  logEmergency = (message: string, path?: string, stack?: string): Observable<unknown> =>
    this.log(LogLevel.EMERGENCY, message, path, stack);

  private log(level: LogLevel, message: string, path?: string, stack?: string): Observable<unknown> {
    if (this.config.useBetterstack) {
      return this.http.post(`${this.config.siteName}/log`, { level, path, message, stack });
    } else {
      console.log('Log: ', { level, message, stack });
    }
    return of(null);
  }
}
